import { ACTION_SET_CONFIG } from "../action";

export default function reduceConfig(state = {
	livePostsNumberOfItems: 5,
}, action){
	switch (action.type) {
		case ACTION_SET_CONFIG:
			return {
				...state,
				[action.payload.key]: action.payload.value,
			}
	}
	return state;
};
